const getResponseType = message => {
  if (message.practiceGroup) {
    var _message$onboarding;
    return (_message$onboarding = message.onboarding) === null || _message$onboarding === void 0 ? void 0 : _message$onboarding.responseType;
  } else if (message.qualityReviewGroup) {
    return message.escalated ? "esc" : "qualityReviewGroup";
  }
  return null;
};
export const calculateReviewSummary = (message, forExperts) => {
  const summary = {
    title: "",
    subtitle: "",
    hasError: false,
    hasCorrectReply: false
  };
  const responseType = getResponseType(message);
  const escalateReason = message.escalateReason;
  const prefix = forExperts ? "You" : "Candidate";
  if (!responseType) {
    if (process.env.REACT_APP_NAME !== "ExpertWebApp") {
      summary.title = "This practice task has not been reviewed yet";
    }
  } else if (responseType === "esc") {
    if (!escalateReason) {
      summary.subtitle = `${prefix} incorrectly replied to this task`;
      summary.hasError = true;
    } else {
      summary.subtitle = `${prefix} correctly forwarded this task`;
      summary.hasCorrectReply = true;
    }
  } else if (responseType === "dia") {
    if (escalateReason) {
      summary.subtitle = `${prefix} incorrectly forwarded this task`;
      summary.hasError = true;
    } else {
      summary.subtitle = `${prefix} correctly replied to this task`;
      summary.hasCorrectReply = true;
    }
  } else if (responseType === "qualityReviewGroup") {
    summary.subtitle = "Expert scored";
    summary.hasCorrectReply = true;
  }
  return summary;
};
export const calculateReviewSummaryPracticeQuestion = (message, t) => {
  const summary = {
    title: "",
    subtitle: "",
    hasError: false,
    hasCorrectReply: false
  };
  const responseType = getResponseType(message);
  const escalateReason = message.escalateReason;
  if (!responseType) {
    if (process.env.REACT_APP_NAME !== "ExpertWebApp") {
      summary.title = t("This practice task has not been reviewed yet");
    }
  } else if (responseType === "esc") {
    if (!escalateReason) {
      summary.subtitle = t("Message incorrectly responded to, should have been forwarded");
      summary.hasError = true;
    } else {
      summary.subtitle = t("Message correctly forwarded");
      summary.hasCorrectReply = true;
    }
  } else if (responseType === "dia") {
    if (escalateReason) {
      summary.subtitle = t("Message incorrectly forwarded, should have been responded to");
      summary.hasError = true;
    }
  }
  return summary;
};
export const prepareReviewCriteria = (message, reviewSummary) => {
  const rc = message.reviewCriteria ? [...message.reviewCriteria] : [];
  let reviewNote = "";
  let isReviewComplete = true;
  rc.forEach(rc => {
    if (reviewSummary.hasCorrectReply) {
      if (message.onboarding.responseType === "esc") {
        rc.score = rc.reviewScheme === "5-stars" ? 5 : 1;
      } else {
        rc.score = rc.score === null ? -1 : rc.score;
        rc.text = rc.text === null ? "" : rc.text;
        reviewNote += rc.name;
        reviewNote += "\r\n\r\n\r\n\r\n";
        isReviewComplete = !rc.optional ? true : false;
      }
    } else {
      rc.score = rc.reviewScheme === "5-stars" ? 1 : 0;
    }
  });
  return {
    isReviewComplete,
    reviewNote,
    reviewCriteria: rc
  };
};